import { render, staticRenderFns } from "./ShowNumberOfRequest.vue?vue&type=template&id=0c013cc0&scoped=true"
import script from "./ShowNumberOfRequest.vue?vue&type=script&lang=js"
export * from "./ShowNumberOfRequest.vue?vue&type=script&lang=js"
import style0 from "./ShowNumberOfRequest.vue?vue&type=style&index=0&id=0c013cc0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c013cc0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c013cc0')) {
      api.createRecord('0c013cc0', component.options)
    } else {
      api.reload('0c013cc0', component.options)
    }
    module.hot.accept("./ShowNumberOfRequest.vue?vue&type=template&id=0c013cc0&scoped=true", function () {
      api.rerender('0c013cc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/other/ShowNumberOfRequest.vue"
export default component.exports